import { render, staticRenderFns } from "./statistics-item.vue?vue&type=template&id=b75e816e"
import script from "./statistics-item.vue?vue&type=script&lang=ts"
export * from "./statistics-item.vue?vue&type=script&lang=ts"
import style0 from "./statistics-item.vue?vue&type=style&index=0&id=b75e816e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports